import React, { useMemo } from "react";
import "./RangeBar.scss"

type RangeBarProps = {
    colorClass: string,
    title: string,
    configData: any,
    valueData: any
}

const RangeBar = ({colorClass, title, configData, valueData} : RangeBarProps) => {

    const scaleNumbers = useMemo(()=>{
        let scale = [] as any;
        for (let i = configData.minRange; i <= configData.maxRange; i++) {
            scale.push(i);
        }
        return scale;
    }, [configData])

    const calculatedExpectedRange = useMemo(() => {
        const rawMinPos = ((valueData.min - configData.minRange) / (configData.maxRange - configData.minRange)) * 100;
        const rawMaxPos = ((valueData.max - configData.minRange) / (configData.maxRange - configData.minRange)) * 100;
        const minPos = Math.max(0, Math.min(100, rawMinPos));
        const maxPos = Math.max(0, Math.min(100, rawMaxPos));

        return { left: `${minPos}%`, width: `${maxPos - minPos}%`}
    },[valueData, configData]) 

    const calculatedMarkerPosition = useMemo(() => {
        if (!valueData.value) return 0;
        const currentPos = ((valueData.value - configData.minRange) / (configData.maxRange - configData.minRange)) * 100;
        let adjustedCurrentPos = currentPos;
        const scaleSize = (configData.maxRange - (configData.minRange - 1));
        const distance = (scaleSize / 2) - valueData.value;
        adjustedCurrentPos = currentPos + (distance * 0.9);
        return {left: `${Math.max(0, Math.min(100, adjustedCurrentPos))}%`, prevLeft: currentPos}
    }, [valueData, configData])

    const showWarning = useMemo(()=>{
        if (valueData.min !== null && valueData.max !== null)
            {
                return valueData.value < valueData.min;
            } 
        return false;
    },[valueData])

    return  (
    <div className="range-bar-wrapper">

        <div className={`range-bar-container range-bar-container--${colorClass}`}>
                <div className="range-bar-title">{title}</div>
                {showWarning ? <span className="warning-icon" title="Value is below minimum">!</span> : ''}
                <div className="range-bar">
                    <div className="range-bar__expected" style={{...calculatedExpectedRange}}></div> 
                    <div className="range-bar__track">
                        <div className="range-bar__numbers">
                            {
                                scaleNumbers.map((number)=>{
                                    return <div key={number}>{number}</div>
                                })
                            }
                        </div>
                        <div className="range-bar__marker" style={{...calculatedMarkerPosition}}>
                            <span className="marker-value">{valueData.value}</span>
                        </div>
                    </div>      
                </div>
        </div>
    </div>
    )
}

export default RangeBar;